export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Sobre Nosotros',
      projects: 'Promociones',
      contact: 'Contacto',
      legal: 'Aviso Legal',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies'
    },
    home: {
      hero: {
        title: 'PASTORIA SERRALTA',
        subtitle: 'Viviendas de calidad en Baleares para la clase media residente',
        cta: 'Ver promociones'
      },
      mission: {
        title: 'Nuestra Misión',
        text: 'Convertirnos en un promotor inmobiliario de referencia en el mercado balear que se identifique por la adecuada ubicación de sus promociones, la orientación al comprador residente de clase media, precios atractivos, buenas calidades y la cercanía entre promotor y comprador.'
      },
      projects: {
        title: 'Promociones en Curso',
        viewAll: 'Ver todas las promociones'
      }
    },
    about: {
      title: 'Sobre Nosotros',
      whoWeAre: {
        title: 'Quiénes Somos',
        text: 'PASTORIA SERRALTA, S.L. fue creada en 2018 con el objetivo de aprovechar las nuevas oportunidades de negocio identificadas en el mercado inmobiliario balear como resultado de la evolución del sector desde la crisis inmobiliaria iniciada en España en 2009.'
      },
      vision: {
        title: 'Visión',
        text: 'El crecimiento de la demanda de vivienda en Baleares, especialmente aquella que demanda la clase media residente, provocará un desajuste con la oferta de vivienda durante los próximos años lo cual supondrá una oportunidad de negocio en ese segmento del mercado inmobiliario.'
      },
      mission: {
        title: 'Misión',
        text: 'Convertirnos en un promotor inmobiliario de referencia en el mercado balear que se identifique por la adecuada ubicación de sus promociones, la orientación al comprador residente de clase media, precios atractivos, buenas calidades y la cercanía entre promotor y comprador.'
      }
    },
    projects: {
      title: 'Nuestras Promociones',
      filter: {
        all: 'Todas',
        inProgress: 'En Curso',
        completed: 'Terminadas'
      },
      status: {
        sold: 'VENDIDO',
        inProgress: 'En Curso',
        completed: 'Terminada'
      },
      details: {
        location: 'Ubicación',
        status: 'Estado',
        features: 'Características',
        gallery: 'Galería',
        contact: 'Solicitar Información',
        disclaimer: 'Las imágenes mostradas tienen carácter meramente orientativo y no contractual. Podrán ser modificadas por PASTORIA SERRALTA S.L. durante el desarrollo del proyecto por motivos técnicos, legales o comerciales.'
      }
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Estamos aquí para ayudarle',
      address: 'Dirección',
      phone: 'Teléfono',
      email: 'Correo Electrónico',
      addressValue: 'Cno. Son Rapiña, núm. 8 1ºA, 07013 Palma – Islas Baleares (España)',
      phoneValue: '+34 638 28 12 01',
      emailValue: 'info@pastoria-serralta.com'
    },
    legal: {
      title: 'Aviso Legal',
      content: `<h2>1. IDENTIFICACIÓN Y TITULARIDAD</h2>
        <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa a los usuarios de los datos identificativos del titular del sitio web:</p>
        <ul>
          <li><strong>Titular:</strong> PASTORIA SERRALTA, S.L.</li>
          <li><strong>NIF:</strong> B16576076</li>
          <li><strong>Domicilio Social:</strong> Cno. Son Rapiña, núm. 8 1ºA, 07013 Palma – Islas Baleares (España)</li>
          <li><strong>Correo electrónico:</strong> info@pastoria-serralta.com</li>
          <li><strong>Teléfono:</strong> +34 638 28 12 01</li>
          <li><strong>Sitio Web:</strong> https://www.pastoria-serralta.com</li>
          <li><strong>Actividad:</strong> Promoción inmobiliaria</li>
        </ul>
        
        <h2>2. OBJETO</h2>
        <p>El presente sitio web tiene como finalidad proporcionar información sobre los servicios de promoción inmobiliaria de PASTORIA SERRALTA, S.L., así como las promociones de viviendas disponibles en las Islas Baleares.</p>
        <p>El Titular se reserva el derecho a modificar en cualquier momento la presentación, configuración y localización del sitio web, así como los contenidos, servicios y las condiciones de acceso, sin necesidad de previo aviso.</p>
        
        <h2>3. CONDICIONES DE USO</h2>
        <p>El acceso al sitio web es gratuito y no requiere registro previo. Sin embargo, el uso de determinados servicios puede requerir la cumplimentación de formularios y la aceptación de condiciones específicas.</p>
        <p>El usuario se compromete a:</p>
        <ul>
          <li>Hacer un uso correcto del sitio web conforme a la ley y las buenas costumbres.</li>
          <li>No realizar actividades ilícitas o contrarias a la buena fe.</li>
          <li>No difundir contenidos de carácter racista, xenófobo, pornográfico, de apología del terrorismo o que atenten contra los derechos humanos.</li>
          <li>No introducir virus informáticos, archivos defectuosos o cualquier otro software que pueda causar daños.</li>
        </ul>
        
        <h2>4. PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
        <p>Todos los contenidos del sitio web, incluyendo a título enunciativo pero no limitativo: textos, fotografías, gráficos, imágenes, iconos, tecnología, software, enlaces y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y códigos fuente, son propiedad intelectual del Titular o de terceros, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual.</p>
        <p>Las marcas, nombres comerciales o signos distintivos son titularidad del Titular o de terceros, sin que pueda entenderse que el acceso al sitio web atribuya ningún derecho sobre los mismos.</p>
        <p>Queda prohibida la reproducción, transformación, distribución, comunicación pública, puesta a disposición del público y, en general, cualquier otra forma de explotación de los elementos referidos, sin autorización expresa y por escrito del Titular.</p>
        
        <h2>5. EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD</h2>
        <p>El Titular no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del sitio web, o la transmisión de virus o programas maliciosos a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.</p>
        
        <h2>6. ENLACES</h2>
        <p>Este sitio web puede contener enlaces a páginas externas. El Titular no se hace responsable del contenido, disponibilidad o política de privacidad de las páginas enlazadas.</p>
        
        <h2>7. MODIFICACIONES</h2>
        <p>El Titular se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que estos aparezcan presentados o localizados en su portal.</p>
        
        <h2>8. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h2>
        <p>La relación entre el Titular y el Usuario se regirá por la legislación española vigente. Para la resolución de cualquier controversia las partes se someterán a los Juzgados y Tribunales del domicilio del usuario, de conformidad con lo dispuesto en la legislación aplicable en materia de consumidores y usuarios.</p>
        
        <p class="text-sm text-gray-500 mt-8"><em>Última actualización: Julio 2025</em></p>`
    },
    privacy: {
      title: 'Política de Privacidad',
      content: `<h2>1. RESPONSABLE DEL TRATAMIENTO</h2>
        <p>De conformidad con lo dispuesto en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le informamos que los datos personales que nos facilite serán tratados por:</p>
        <ul>
          <li><strong>Responsable:</strong> PASTORIA SERRALTA, S.L.</li>
          <li><strong>NIF:</strong> B16576076</li>
          <li><strong>Domicilio:</strong> Cno. Son Rapiña, núm. 8 1ºA, 07013 Palma – Islas Baleares (España)</li>
          <li><strong>Correo electrónico:</strong> info@pastoria-serralta.com</li>
          <li><strong>Teléfono:</strong> +34 638 28 12 01</li>
        </ul>
        
        <h2>2. FINALIDADES DEL TRATAMIENTO</h2>
        <p>Los datos personales que nos proporcione serán tratados con las siguientes finalidades:</p>
        <ul>
          <li><strong>Gestión de consultas:</strong> Responder a las solicitudes de información sobre nuestros servicios y promociones inmobiliarias.</li>
          <li><strong>Gestión comercial:</strong> Mantener la relación comercial, incluyendo la gestión de presupuestos, contratos y servicios solicitados.</li>
          <li><strong>Comunicaciones comerciales:</strong> Envío de información sobre nuevas promociones, ofertas y novedades de PASTORIA SERRALTA, S.L. (solo si ha dado su consentimiento expreso).</li>
          <li><strong>Cumplimiento legal:</strong> Cumplir con las obligaciones legales que nos resulten aplicables.</li>
        </ul>
        
        <h2>3. LEGITIMACIÓN DEL TRATAMIENTO</h2>
        <p>La base legal para el tratamiento de sus datos es:</p>
        <ul>
          <li><strong>Consentimiento del interesado:</strong> Para el envío de comunicaciones comerciales y la recopilación de datos a través de formularios.</li>
          <li><strong>Ejecución de un contrato:</strong> Para la gestión de la relación comercial y prestación de servicios.</li>
          <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y atender consultas.</li>
          <li><strong>Cumplimiento de obligaciones legales:</strong> Para cumplir con las obligaciones fiscales, contables y de prevención del blanqueo de capitales.</li>
        </ul>
        
        <h2>4. DESTINATARIOS DE LOS DATOS</h2>
        <p>Sus datos podrán ser comunicados a:</p>
        <ul>
          <li>Administraciones Públicas competentes, en los casos previstos por la Ley.</li>
          <li>Entidades financieras para la gestión de pagos y financiación de viviendas.</li>
          <li>Notarías y registros de la propiedad para la formalización de escrituras.</li>
          <li>Proveedores de servicios tecnológicos que actúan como encargados del tratamiento.</li>
        </ul>
        <p>No se realizan transferencias internacionales de datos fuera del Espacio Económico Europeo (EEE).</p>
        
        <h2>5. PLAZOS DE CONSERVACIÓN</h2>
        <p>Los datos personales se conservarán durante los siguientes plazos:</p>
        <ul>
          <li><strong>Datos de contacto y consultas:</strong> Mientras no solicite su supresión y, posteriormente, durante el plazo de prescripción de las acciones legales (máximo 6 años).</li>
          <li><strong>Datos contractuales:</strong> Durante la vigencia de la relación contractual y, posteriormente, durante el plazo de prescripción de las acciones legales aplicables (hasta 15 años para acciones derivadas de contratos inmobiliarios).</li>
          <li><strong>Datos fiscales y contables:</strong> 6 años conforme a la legislación mercantil.</li>
          <li><strong>Comunicaciones comerciales:</strong> Hasta que revoque su consentimiento.</li>
        </ul>
        
        <h2>6. DERECHOS DEL INTERESADO</h2>
        <p>Usted tiene derecho a:</p>
        <ul>
          <li><strong>Acceso:</strong> Conocer qué datos personales tratamos sobre usted.</li>
          <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos.</li>
          <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
          <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento en determinadas circunstancias.</li>
          <li><strong>Portabilidad:</strong> Recibir sus datos en un formato estructurado y de uso común.</li>
          <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos en determinadas circunstancias.</li>
          <li><strong>Retirar el consentimiento:</strong> Revocar el consentimiento prestado en cualquier momento.</li>
        </ul>
        <p>Para ejercer estos derechos, puede dirigirse a: <strong>info@pastoria-serralta.com</strong> o por correo postal a nuestra dirección, adjuntando copia de su DNI o documento identificativo.</p>
        
        <h2>7. DERECHO A PRESENTAR RECLAMACIÓN</h2>
        <p>Si considera que el tratamiento de sus datos personales vulnera la normativa de protección de datos, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD):</p>
        <ul>
          <li><strong>Dirección:</strong> C/ Jorge Juan, 6, 28001 Madrid</li>
          <li><strong>Web:</strong> <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">www.aepd.es</a></li>
        </ul>
        
        <h2>8. MEDIDAS DE SEGURIDAD</h2>
        <p>PASTORIA SERRALTA, S.L. ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, de acuerdo con lo establecido en el RGPD.</p>
        
        <h2>9. ACTUALIZACIONES DE LA POLÍTICA</h2>
        <p>Esta política de privacidad puede ser actualizada periódicamente para adaptarse a los cambios normativos o a las prácticas de la empresa. Le recomendamos revisarla periódicamente.</p>
        
        <p class="text-sm text-gray-500 mt-8"><em>Última actualización: Julio 2025</em></p>`
    },
    cookies: {
      title: 'Política de Cookies',
      content: `<h2>1. ¿QUÉ SON LAS COOKIES?</h2>
        <p>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (ordenador, tablet o móvil) cuando visita un sitio web. Las cookies permiten que el sitio web recuerde sus acciones y preferencias durante un período de tiempo, para que no tenga que volver a introducirlas cada vez que visite el sitio o navegue de una página a otra.</p>
        
        <h2>2. TIPOS DE COOKIES QUE UTILIZAMOS</h2>
        <p>En cumplimiento del artículo 22 de la Ley 34/2002 de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE) y la Directiva 2002/58/CE modificada por la Directiva 2009/136/CE, le informamos sobre las cookies que utilizamos:</p>
        
        <h3>2.1. Cookies Necesarias (Técnicas)</h3>
        <p>Son esenciales para el funcionamiento del sitio web. Sin estas cookies, el sitio no puede funcionar correctamente.</p>
        <table class="w-full border-collapse border border-gray-300 my-4">
          <thead>
            <tr class="bg-gray-100">
              <th class="border border-gray-300 p-2 text-left">Nombre</th>
              <th class="border border-gray-300 p-2 text-left">Finalidad</th>
              <th class="border border-gray-300 p-2 text-left">Duración</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-gray-300 p-2">pastoria_cookie_consent</td>
              <td class="border border-gray-300 p-2">Almacena las preferencias de cookies del usuario</td>
              <td class="border border-gray-300 p-2">1 año</td>
            </tr>
            <tr>
              <td class="border border-gray-300 p-2">pastoria_language</td>
              <td class="border border-gray-300 p-2">Almacena la preferencia de idioma del usuario</td>
              <td class="border border-gray-300 p-2">1 año</td>
            </tr>
          </tbody>
        </table>
        
        <h3>2.2. Cookies de Terceros</h3>
        <p>Este sitio web utiliza servicios de terceros que pueden establecer sus propias cookies:</p>
        <table class="w-full border-collapse border border-gray-300 my-4">
          <thead>
            <tr class="bg-gray-100">
              <th class="border border-gray-300 p-2 text-left">Proveedor</th>
              <th class="border border-gray-300 p-2 text-left">Finalidad</th>
              <th class="border border-gray-300 p-2 text-left">Más información</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-gray-300 p-2">Google Maps</td>
              <td class="border border-gray-300 p-2">Mostrar mapas de ubicación en la página de contacto</td>
              <td class="border border-gray-300 p-2"><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Política de privacidad de Google</a></td>
            </tr>
            <tr>
              <td class="border border-gray-300 p-2">Google Fonts</td>
              <td class="border border-gray-300 p-2">Cargar fuentes tipográficas</td>
              <td class="border border-gray-300 p-2"><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Política de privacidad de Google</a></td>
            </tr>
          </tbody>
        </table>
        
        <h2>3. GESTIÓN DE COOKIES</h2>
        <p>Puede gestionar sus preferencias de cookies de varias formas:</p>
        
        <h3>3.1. A través de nuestro panel de configuración</h3>
        <p>Al acceder a nuestro sitio web por primera vez, se mostrará un banner donde podrá aceptar o rechazar las cookies, así como personalizar sus preferencias.</p>
        
        <h3>3.2. A través de su navegador</h3>
        <p>Puede configurar su navegador para que rechace las cookies o le avise cuando un sitio web intente establecerlas. Aquí le indicamos cómo hacerlo en los navegadores más comunes:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Microsoft Edge</a></li>
        </ul>
        <p><strong>Nota:</strong> Si desactiva las cookies, es posible que algunas funciones del sitio web no estén disponibles.</p>
        
        <h2>4. BASE LEGAL</h2>
        <p>El tratamiento de datos derivado de las cookies se basa en:</p>
        <ul>
          <li><strong>Cookies necesarias:</strong> Interés legítimo del responsable para el funcionamiento del sitio web.</li>
          <li><strong>Cookies de terceros:</strong> Consentimiento del usuario.</li>
        </ul>
        
        <h2>5. ACTUALIZACIONES DE LA POLÍTICA</h2>
        <p>Esta política de cookies puede actualizarse periódicamente para reflejar cambios en las cookies que utilizamos o por motivos legales. Le recomendamos revisarla periódicamente.</p>
        
        <h2>6. MÁS INFORMACIÓN</h2>
        <p>Para más información sobre las cookies, puede consultar:</p>
        <ul>
          <li><a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">www.aboutcookies.org</a></li>
          <li><a href="https://www.aepd.es/es/areas-de-actuacion/internet-y-redes-sociales/cookies" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Guía de la AEPD sobre cookies</a></li>
        </ul>
        
        <h2>7. CONTACTO</h2>
        <p>Si tiene cualquier duda sobre nuestra política de cookies, puede contactarnos en:</p>
        <ul>
          <li><strong>Email:</strong> info@pastoria-serralta.com</li>
          <li><strong>Teléfono:</strong> +34 638 28 12 01</li>
        </ul>
        
        <p class="text-sm text-gray-500 mt-8"><em>Última actualización: Julio 2025</em></p>`
    },
    footer: {
      company: 'PASTORIA SERRALTA, S.L.',
      rights: '© 2025 Todos los derechos reservados',
      quickLinks: 'Enlaces Rápidos'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      contact: 'Contact',
      legal: 'Legal Notice',
      privacy: 'Privacy Policy',
      cookies: 'Cookies Policy'
    },
    home: {
      hero: {
        title: 'PASTORIA SERRALTA',
        subtitle: 'Quality housing in the Balearic Islands for local middle-class residents',
        cta: 'View projects'
      },
      mission: {
        title: 'Our Mission',
        text: 'Become a benchmark real-estate developer in the Balearic market, known for well-located projects, a focus on local middle-class buyers, attractive pricing, high quality, and close, transparent relationships between developer and buyer.'
      },
      projects: {
        title: 'Projects in Progress',
        viewAll: 'View all projects'
      }
    },
    about: {
      title: 'About Us',
      whoWeAre: {
        title: 'Who We Are',
        text: 'PASTORIA SERRALTA, S.L. was founded in 2018 to seize new business opportunities identified in the Balearic real-estate market following the sector\'s evolution after Spain\'s 2009 housing crisis.'
      },
      vision: {
        title: 'Vision',
        text: 'Rising housing demand in the Balearic Islands—especially from local middle-class residents—will outpace supply in the coming years, creating a significant opportunity in this market segment.'
      },
      mission: {
        title: 'Mission',
        text: 'Become a benchmark real-estate developer in the Balearic market, known for well-located projects, a focus on local middle-class buyers, attractive pricing, high quality, and close, transparent relationships between developer and buyer.'
      }
    },
    projects: {
      title: 'Our Projects',
      filter: {
        all: 'All',
        inProgress: 'In Progress',
        completed: 'Completed'
      },
      status: {
        sold: 'SOLD',
        inProgress: 'In Progress',
        completed: 'Completed'
      },
      details: {
        location: 'Location',
        status: 'Status',
        features: 'Features',
        gallery: 'Gallery',
        contact: 'Request Information',
        disclaimer: 'The images shown are merely illustrative and non-contractual. They may be modified by PASTORIA SERRALTA S.L. during the development of the project for technical, legal or commercial reasons.'
      }
    },
    contact: {
      title: 'Contact',
      subtitle: 'We are here to help you',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      addressValue: 'Cno. Son Rapiña, núm. 8 1ºA, 07013 Palma – Balearic Islands (Spain)',
      phoneValue: '+34 638 28 12 01',
      emailValue: 'info@pastoria-serralta.com'
    },
    legal: {
      title: 'Legal Notice',
      content: `<h2>1. IDENTIFICATION AND OWNERSHIP</h2>
        <p>In compliance with article 10 of Law 34/2002, of July 11, on Information Society Services and Electronic Commerce (LSSI-CE), users are informed of the identifying data of the website owner:</p>
        <ul>
          <li><strong>Owner:</strong> PASTORIA SERRALTA, S.L.</li>
          <li><strong>Tax ID:</strong> B16576076</li>
          <li><strong>Registered Address:</strong> Cno. Son Rapiña, núm. 8 1ºA, 07013 Palma – Balearic Islands (Spain)</li>
          <li><strong>Email:</strong> info@pastoria-serralta.com</li>
          <li><strong>Phone:</strong> +34 638 28 12 01</li>
          <li><strong>Website:</strong> https://www.pastoria-serralta.com</li>
          <li><strong>Activity:</strong> Real estate development</li>
        </ul>
        
        <h2>2. PURPOSE</h2>
        <p>This website aims to provide information about the real estate development services of PASTORIA SERRALTA, S.L., as well as the housing developments available in the Balearic Islands.</p>
        <p>The Owner reserves the right to modify at any time the presentation, configuration and location of the website, as well as the content, services and access conditions, without prior notice.</p>
        
        <h2>3. TERMS OF USE</h2>
        <p>Access to the website is free and does not require prior registration. However, the use of certain services may require completing forms and accepting specific conditions.</p>
        <p>The user agrees to:</p>
        <ul>
          <li>Make proper use of the website in accordance with the law and good customs.</li>
          <li>Not carry out illegal activities or activities contrary to good faith.</li>
          <li>Not disseminate racist, xenophobic, pornographic content, content that glorifies terrorism, or that violates human rights.</li>
          <li>Not introduce computer viruses, defective files, or any other software that may cause damage.</li>
        </ul>
        
        <h2>4. INTELLECTUAL AND INDUSTRIAL PROPERTY</h2>
        <p>All website content, including but not limited to: texts, photographs, graphics, images, icons, technology, software, links and other audiovisual or sound content, as well as its graphic design and source codes, are the intellectual property of the Owner or third parties, without any of the exploitation rights recognized by current intellectual property regulations being understood as transferred to the user.</p>
        <p>Trademarks, trade names or distinctive signs are owned by the Owner or third parties, and access to the website cannot be understood as granting any rights over them.</p>
        <p>Reproduction, transformation, distribution, public communication, making available to the public and, in general, any other form of exploitation of the aforementioned elements is prohibited without the express written authorization of the Owner.</p>
        
        <h2>5. EXCLUSION OF WARRANTIES AND LIABILITY</h2>
        <p>The Owner is not responsible, under any circumstances, for damages of any nature that may be caused, including: errors or omissions in the content, lack of availability of the website, or the transmission of viruses or malicious programs despite having adopted all necessary technological measures to avoid it.</p>
        
        <h2>6. LINKS</h2>
        <p>This website may contain links to external pages. The Owner is not responsible for the content, availability or privacy policy of linked pages.</p>
        
        <h2>7. MODIFICATIONS</h2>
        <p>The Owner reserves the right to make without prior notice the modifications it deems appropriate on its portal, being able to change, delete or add both the content and services provided through it and the way in which they are presented or located on its portal.</p>
        
        <h2>8. APPLICABLE LAW AND JURISDICTION</h2>
        <p>The relationship between the Owner and the User shall be governed by current Spanish legislation. For the resolution of any dispute, the parties shall submit to the Courts and Tribunals of the user's domicile, in accordance with the provisions of the applicable consumer protection legislation.</p>
        
        <p class="text-sm text-gray-500 mt-8"><em>Last updated: July 2025</em></p>`
    },
    privacy: {
      title: 'Privacy Policy',
      content: `<h2>1. DATA CONTROLLER</h2>
        <p>In accordance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 (GDPR) and Organic Law 3/2018, of December 5, on Personal Data Protection and guarantee of digital rights (LOPDGDD), we inform you that the personal data you provide will be processed by:</p>
        <ul>
          <li><strong>Controller:</strong> PASTORIA SERRALTA, S.L.</li>
          <li><strong>Tax ID:</strong> B16576076</li>
          <li><strong>Address:</strong> Cno. Son Rapiña, núm. 8 1ºA, 07013 Palma – Balearic Islands (Spain)</li>
          <li><strong>Email:</strong> info@pastoria-serralta.com</li>
          <li><strong>Phone:</strong> +34 638 28 12 01</li>
        </ul>
        
        <h2>2. PURPOSES OF PROCESSING</h2>
        <p>The personal data you provide will be processed for the following purposes:</p>
        <ul>
          <li><strong>Query management:</strong> Responding to requests for information about our services and real estate developments.</li>
          <li><strong>Commercial management:</strong> Maintaining the commercial relationship, including management of quotes, contracts and requested services.</li>
          <li><strong>Commercial communications:</strong> Sending information about new developments, offers and news from PASTORIA SERRALTA, S.L. (only if you have given express consent).</li>
          <li><strong>Legal compliance:</strong> Complying with applicable legal obligations.</li>
        </ul>
        
        <h2>3. LEGAL BASIS FOR PROCESSING</h2>
        <p>The legal basis for processing your data is:</p>
        <ul>
          <li><strong>Consent of the data subject:</strong> For sending commercial communications and collecting data through forms.</li>
          <li><strong>Performance of a contract:</strong> For managing the commercial relationship and providing services.</li>
          <li><strong>Legitimate interest:</strong> To improve our services and respond to queries.</li>
          <li><strong>Compliance with legal obligations:</strong> To comply with tax, accounting and anti-money laundering obligations.</li>
        </ul>
        
        <h2>4. DATA RECIPIENTS</h2>
        <p>Your data may be communicated to:</p>
        <ul>
          <li>Competent Public Administrations, in cases provided by Law.</li>
          <li>Financial entities for payment management and housing financing.</li>
          <li>Notaries and property registries for the formalization of deeds.</li>
          <li>Technology service providers acting as data processors.</li>
        </ul>
        <p>No international data transfers are made outside the European Economic Area (EEA).</p>
        
        <h2>5. RETENTION PERIODS</h2>
        <p>Personal data will be retained for the following periods:</p>
        <ul>
          <li><strong>Contact and query data:</strong> As long as you do not request deletion and, subsequently, during the limitation period for legal actions (maximum 6 years).</li>
          <li><strong>Contractual data:</strong> During the term of the contractual relationship and, subsequently, during the applicable limitation period for legal actions (up to 15 years for actions arising from real estate contracts).</li>
          <li><strong>Tax and accounting data:</strong> 6 years in accordance with commercial legislation.</li>
          <li><strong>Commercial communications:</strong> Until you revoke your consent.</li>
        </ul>
        
        <h2>6. DATA SUBJECT RIGHTS</h2>
        <p>You have the right to:</p>
        <ul>
          <li><strong>Access:</strong> Know what personal data we process about you.</li>
          <li><strong>Rectification:</strong> Request correction of inaccurate or incomplete data.</li>
          <li><strong>Erasure:</strong> Request deletion of your data when no longer necessary.</li>
          <li><strong>Restriction:</strong> Request restriction of processing in certain circumstances.</li>
          <li><strong>Portability:</strong> Receive your data in a structured, commonly used format.</li>
          <li><strong>Objection:</strong> Object to processing of your data in certain circumstances.</li>
          <li><strong>Withdraw consent:</strong> Revoke consent given at any time.</li>
        </ul>
        <p>To exercise these rights, you can contact: <strong>info@pastoria-serralta.com</strong> or by post to our address, attaching a copy of your ID or identification document.</p>
        
        <h2>7. RIGHT TO LODGE A COMPLAINT</h2>
        <p>If you consider that the processing of your personal data violates data protection regulations, you have the right to lodge a complaint with the Spanish Data Protection Agency (AEPD):</p>
        <ul>
          <li><strong>Address:</strong> C/ Jorge Juan, 6, 28001 Madrid</li>
          <li><strong>Web:</strong> <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">www.aepd.es</a></li>
        </ul>
        
        <h2>8. SECURITY MEASURES</h2>
        <p>PASTORIA SERRALTA, S.L. has adopted the necessary technical and organizational measures to guarantee the security of personal data and prevent their alteration, loss, processing or unauthorized access, in accordance with the provisions of the GDPR.</p>
        
        <h2>9. POLICY UPDATES</h2>
        <p>This privacy policy may be updated periodically to adapt to regulatory changes or company practices. We recommend reviewing it regularly.</p>
        
        <p class="text-sm text-gray-500 mt-8"><em>Last updated: July 2025</em></p>`
    },
    cookies: {
      title: 'Cookies Policy',
      content: `<h2>1. WHAT ARE COOKIES?</h2>
        <p>Cookies are small text files that are stored on your device (computer, tablet or mobile) when you visit a website. Cookies allow the website to remember your actions and preferences over a period of time, so you don't have to re-enter them every time you visit the site or browse from one page to another.</p>
        
        <h2>2. TYPES OF COOKIES WE USE</h2>
        <p>In compliance with article 22 of Law 34/2002 on Information Society Services and Electronic Commerce (LSSI-CE) and Directive 2002/58/EC as amended by Directive 2009/136/EC, we inform you about the cookies we use:</p>
        
        <h3>2.1. Necessary Cookies (Technical)</h3>
        <p>These are essential for the website to function. Without these cookies, the site cannot work properly.</p>
        <table class="w-full border-collapse border border-gray-300 my-4">
          <thead>
            <tr class="bg-gray-100">
              <th class="border border-gray-300 p-2 text-left">Name</th>
              <th class="border border-gray-300 p-2 text-left">Purpose</th>
              <th class="border border-gray-300 p-2 text-left">Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-gray-300 p-2">pastoria_cookie_consent</td>
              <td class="border border-gray-300 p-2">Stores user cookie preferences</td>
              <td class="border border-gray-300 p-2">1 year</td>
            </tr>
            <tr>
              <td class="border border-gray-300 p-2">pastoria_language</td>
              <td class="border border-gray-300 p-2">Stores user language preference</td>
              <td class="border border-gray-300 p-2">1 year</td>
            </tr>
          </tbody>
        </table>
        
        <h3>2.2. Third-Party Cookies</h3>
        <p>This website uses third-party services that may set their own cookies:</p>
        <table class="w-full border-collapse border border-gray-300 my-4">
          <thead>
            <tr class="bg-gray-100">
              <th class="border border-gray-300 p-2 text-left">Provider</th>
              <th class="border border-gray-300 p-2 text-left">Purpose</th>
              <th class="border border-gray-300 p-2 text-left">More information</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-gray-300 p-2">Google Maps</td>
              <td class="border border-gray-300 p-2">Display location maps on the contact page</td>
              <td class="border border-gray-300 p-2"><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Google Privacy Policy</a></td>
            </tr>
            <tr>
              <td class="border border-gray-300 p-2">Google Fonts</td>
              <td class="border border-gray-300 p-2">Load web fonts</td>
              <td class="border border-gray-300 p-2"><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Google Privacy Policy</a></td>
            </tr>
          </tbody>
        </table>
        
        <h2>3. COOKIE MANAGEMENT</h2>
        <p>You can manage your cookie preferences in several ways:</p>
        
        <h3>3.1. Through our settings panel</h3>
        <p>When you first access our website, a banner will be displayed where you can accept or reject cookies, as well as customize your preferences.</p>
        
        <h3>3.2. Through your browser</h3>
        <p>You can configure your browser to reject cookies or warn you when a website tries to set them. Here's how to do it in the most common browsers:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Safari</a></li>
          <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">Microsoft Edge</a></li>
        </ul>
        <p><strong>Note:</strong> If you disable cookies, some website features may not be available.</p>
        
        <h2>4. LEGAL BASIS</h2>
        <p>Data processing derived from cookies is based on:</p>
        <ul>
          <li><strong>Necessary cookies:</strong> Legitimate interest of the controller for website operation.</li>
          <li><strong>Third-party cookies:</strong> User consent.</li>
        </ul>
        
        <h2>5. POLICY UPDATES</h2>
        <p>This cookie policy may be updated periodically to reflect changes in the cookies we use or for legal reasons. We recommend reviewing it regularly.</p>
        
        <h2>6. MORE INFORMATION</h2>
        <p>For more information about cookies, you can visit:</p>
        <ul>
          <li><a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">www.aboutcookies.org</a></li>
          <li><a href="https://www.aepd.es/es/areas-de-actuacion/internet-y-redes-sociales/cookies" target="_blank" rel="noopener noreferrer" class="text-[#356C8A] hover:underline">AEPD Guide on cookies</a></li>
        </ul>
        
        <h2>7. CONTACT</h2>
        <p>If you have any questions about our cookie policy, you can contact us at:</p>
        <ul>
          <li><strong>Email:</strong> info@pastoria-serralta.com</li>
          <li><strong>Phone:</strong> +34 638 28 12 01</li>
        </ul>
        
        <p class="text-sm text-gray-500 mt-8"><em>Last updated: July 2025</em></p>`
    },
    footer: {
      company: 'PASTORIA SERRALTA, S.L.',
      rights: '© 2025 All rights reserved',
      quickLinks: 'Quick Links'
    }
  }
};

export const projectsData = [
  {
    id: 'serralta-residencial-1',
    slug: 'serralta-residencial-1',
    name: 'SERRALTA RESIDENCIAL I',
    status: 'completed',
    soldPercentage: 100,
    location: 'C/ Pere Oliver Domenge, 21, Palma, Mallorca',
    description: {
      es: 'Promoción de viviendas de alta calidad completamente vendida. Este proyecto marcó el inicio de nuestra trayectoria en el mercado balear, ofreciendo viviendas diseñadas para la clase media residente con excelentes acabados y ubicación privilegiada.',
      en: 'High-quality housing development completely sold out. This project marked the beginning of our trajectory in the Balearic market, offering homes designed for local middle-class residents with excellent finishes and prime location.'
    },
    features: {
      es: [
        '16 viviendas de 1, 2 y 3 dormitorios',
        'Acabados de primera calidad',
        'Plazas de aparcamiento subterráneo',
        'Ubicación céntrica en Palma'
      ],
      en: [
        '16 homes with 1, 2 and 3 bedrooms',
        'First-class finishes',
        'Underground parking spaces',
        'Central location in Palma'
      ]
    },
    images: ['serralta1_image1.jpeg', 'serralta1_image2.jpeg', 'serralta1_image3.jpeg', 'serralta1_image4.jpeg']
  },
  {
    id: 'llac-como-residencial',
    slug: 'llac-como-residencial',
    name: 'LLAC COMO RESIDENCIAL',
    status: 'inProgress',
    soldPercentage: 90,
    location: 'C/Llac Como, 4, Palma, Mallorca',
    description: {
      es: 'Promoción moderna de viviendas con diseño contemporáneo y excelentes calidades. Ubicada en una zona residencial tranquila con fácil acceso a todos los servicios.',
      en: 'Modern housing development with contemporary design and excellent quality. Located in a quiet residential area with easy access to all services.'
    },
    features: {
      es: [
        '6 viviendas de 2 y 3 dormitorios',
        'Terrazas amplias',
        'Piscina comunitaria',
        'Parking y trastero',
        'Certificación energética B',
        'Vistas despejadas'
      ],
      en: [
        '6 homes with 2 and 3 bedrooms',
        'Spacious terraces',
        'Community pool',
        'Parking and storage room',
        'Energy certification B',
        'Clear views'
      ]
    },
    images: ['llac_como_image1.jpg', 'llac_como_image2.jpeg', 'llac_como_image3.jpeg', 'llac_como_image4.jpeg']
  },
  {
    id: 'son-dameto-residencial-1',
    slug: 'son-dameto-residencial-1',
    name: 'SON DAMETO RESIDENCIAL I',
    status: 'inProgress',
    soldPercentage: 90,
    location: 'C/ Andreu Jaume i Nadal, 5 y 7, Palma, Mallorca',
    description: {
      es: 'Desarrollo residencial en la zona de Son Dameto. Viviendas espaciosas con diseño moderno y funcional. Entorno privilegiado con vistas despejadas.',
      en: 'Residential development in the Son Dameto area. Spacious homes with modern and functional design. Privileged setting with clear views.'
    },
    features: {
      es: [
        '10 viviendas de 2 y 3 habitaciones',
        'Zona residencial consolidada',
        '10 aparcamientos y trasteros',
        'Certificación energética B'
      ],
      en: [
        '10 homes with 2 and 3 bedrooms',
        'Established residential area',
        '10 parking spaces and storage rooms',
        'Energy certification B'
      ]
    },
    images: ['son_dameto_image1.jpeg', 'son_dameto_image2.jpeg', 'son_dameto_image3.jpeg', 'son_dameto_image4.jpeg']
  },
  {
    id: 'serralta-residencial-2',
    slug: 'serralta-residencial-2',
    name: 'SERRALTA RESIDENCIAL II',
    status: 'inProgress',
    soldPercentage: 80,
    location: 'C/ Pere Oliver Domenge, 15, Palma, Mallorca',
    description: {
      es: 'Segunda fase del exitoso proyecto Serralta Residencial. Continuando con nuestro compromiso de ofrecer viviendas de calidad a precios competitivos.',
      en: 'Second phase of the successful Serralta Residencial project. Continuing our commitment to offer quality homes at competitive prices.'
    },
    features: {
      es: [
        '5 viviendas de nueva construcción',
        'Diseño mediterráneo moderno',
        'Certificación energética B',
        'Áticos Dúplex de 2 y 3 habitaciones'
      ],
      en: [
        '5 newly built homes',
        'Modern Mediterranean design',
        'Energy certification B',
        'Duplex penthouses with 2 and 3 bedrooms'
      ]
    },
    images: ['serralta2_new1.jpg', 'serralta2_new2.jpg', 'serralta2_new3.jpg', 'serralta2_new4.jpg']
  },
  {
    id: 'son-ametler-residencial',
    slug: 'son-ametler-residencial',
    name: 'SON AMETLER RESIDENCIAL',
    status: 'inProgress',
    soldPercentage: 60,
    location: 'Camí Son Ametler, 2, Palma, Mallorca',
    description: {
      es: 'Nuestra promoción más reciente en la zona de Son Ametler. Viviendas diseñadas pensando en las necesidades de las familias modernas, con espacios luminosos y funcionales.',
      en: 'Our most recent development in the Son Ametler area. Homes designed with modern families in mind, featuring bright and functional spaces.'
    },
    features: {
      es: [
        '8 viviendas adosadas',
        'Aparcamiento incluido',
        'Posibilidad de piscina privada',
        'Excelente conectividad'
      ],
      en: [
        '8 terraced houses',
        'Parking included',
        'Possibility of private pool',
        'Excellent connectivity'
      ]
    },
    images: ['son_ametler_image1.jpeg', 'son_ametler_image2.jpeg', 'son_ametler_image3.jpeg', 'son_ametler_image4.jpeg']
  }
];